import { render, staticRenderFns } from "./SupportBusiness.vue?vue&type=template&id=68f7c9cc&"
import script from "./supportBusiness.js?vue&type=script&lang=js&"
export * from "./supportBusiness.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports